import { useAuth, overrideConfig } from '@/api/hyper-common'

const fetchRegularBillingHistory = function ({ projectIdx, usageAccountId }, serviceIdx) {
    const { auth } = useAuth({ ...overrideConfig, serviceIdx })
    return auth.axiosIns.post('v1/hyper-common/credit-card/regular-billing/history', { projectIdx, usageAccountId })
}

const fetchRegularBillingInfo = function ({ usageAccountId }, serviceIdx) {
    const { auth } = useAuth({ ...overrideConfig, serviceIdx })
    return auth.axiosIns.get(`/v1/hyper-common/credit-card/regular-billing/usageAccountId/${usageAccountId}`)
}

export default {
    fetchRegularBillingHistory,
    fetchRegularBillingInfo
}
